module.exports = __webpack_public_path__ + "img/53.2f9ff809.jpg";